import { render, staticRenderFns } from "./FormAvatarItem.vue?vue&type=template&id=70f7cb19&"
import script from "./FormAvatarItem.vue?vue&type=script&lang=js&"
export * from "./FormAvatarItem.vue?vue&type=script&lang=js&"
import style0 from "./FormAvatarItem.vue?vue&type=style&index=0&id=70f7cb19&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports